"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.values");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/home/runner/work/react-floatybox/react-floatybox/packages/react-floatybox-docs/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var Device;

(function (Device) {
  Device["BROWSER"] = "BROWSER";
  Device["SERVER"] = "SERVER";
  Device["NATIVE"] = "NATIVE";
})(Device = exports.Device || (exports.Device = {}));

var _Device = Device,
    BROWSER = _Device.BROWSER,
    SERVER = _Device.SERVER,
    NATIVE = _Device.NATIVE;
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var canUseNative = typeof navigator != 'undefined' && navigator.product == 'ReactNative';
var location = canUseNative ? NATIVE : canUseDOM ? BROWSER : SERVER;

function useSSR() {
  var _react_1$useState = react_1.useState(location),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      whereAmI = _react_1$useState2[0],
      setWhereAmI = _react_1$useState2[1];

  var mounted = react_1.useRef(false);
  react_1.useEffect(function () {
    if (mounted.current) return;
    mounted.current = true;
    setWhereAmI(location);
  });
  var useSSRObject = react_1.useMemo(function () {
    return {
      isBrowser: whereAmI === BROWSER,
      isServer: whereAmI === SERVER,
      isNative: whereAmI === NATIVE,
      canUseWorkers: typeof Worker !== 'undefined',
      canUseEventListeners: whereAmI === BROWSER && !!window.addEventListener,
      canUseViewport: whereAmI === BROWSER && !!window.screen
    };
  }, [whereAmI]);
  return react_1.useMemo(function () {
    return Object.assign(Object.values(useSSRObject), useSSRObject);
  }, [whereAmI]);
}

exports["default"] = useSSR;